<template>
  <div class="d-flex flex-end gap-2">
    <McButtonBack />

    <template v-for="item in actionItems">
      <McButton
        v-if="isWaiting"
        :disabled="isLoading"
        :key="item.key"
        :text="item.label"
        :variant="item.variant"
        :icon="item.icon"
        @click="() => handleClickAction(item)"
      />
    </template>

    <RejectModal @transition="handleTransitionRequest" />
    <AcceptModal @transition="handleTransitionRequest" />
  </div>
</template>

<script>
import McButton from '@/components/McButton'
import McButtonBack from '@/components/McButtonBack'
import RejectModal from './RejectModal'
import AcceptModal from './AcceptModal.vue'

import * as Request from '@/services/rest-api/lib/request/request'
import { actionTransitionItems } from '../lib/constants/action-items'

export default {
  components: {
    McButtonBack,
    McButton,
    RejectModal,
    AcceptModal,
  },
  inject: ['isLoading', 'status'],
  computed: {
    actionItems() {
      return actionTransitionItems(this.$t.bind(this))
    },
    isWaiting() {
      return this.status == 'Menunggu'
    },
  },
  methods: {
    handleClickAction(item) {
      this.$bvModal.show(item.idModal)
    },
    async handleTransitionRequest(type, data) {
      const actionItem = this.actionItems.find((item) => item.key == type)

      const res = await Request.transition(this.$route.params.id, data)

      if (res.errors) {
        this.$mcToast.error(actionItem.message.failed)
        this.$bvModal.hide(actionItem.idModal)
        return
      }

      this.$router.push({ name: 'Delivery Request List' })
      this.$mcToast.success(actionItem.message.success)
    },
  },
}
</script>
